export const commentKeys = {
  list: (sectionSuperId: string) => ['comments', sectionSuperId],
  create: (sectionSuperId: string) => ['createComment', sectionSuperId],
  notifications: (sectionSuperId: string) => ['commentNotifications', sectionSuperId],
};
